import { useEffect } from "react";

// Injects a <script type="application/ld+json"> into <head> for rich results.
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => { const e = document.getElementById(id); if (e) e.remove(); };
  }, [id, data]);
  return null;
}
